import { render } from "./FormasPagamentoProduto.vue?vue&type=template&id=02475c05&scoped=true"
import script from "./FormasPagamentoProduto.vue?vue&type=script&lang=js"
export * from "./FormasPagamentoProduto.vue?vue&type=script&lang=js"

import "./FormasPagamentoProduto.vue?vue&type=style&index=0&id=02475c05&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02475c05"]])

export default __exports__